import { QUOTE_FRAGMENT } from 'customer-flows/gql/fragments/quote'
import { useMutation } from 'glimmer-apollo'
import { parse, print } from 'graphql'

export type RedemptionCodeErrorCode =
  | 'AUTHORIZED_AMOUNT_GT_TOTAL'
  | 'INCOMPATIBLE_CODE'
  | 'INSUFFICIENT_FUNDS'
  | 'INTERNAL_UNEXPECTED'
  | 'INVALID_AMOUNT'
  | 'INVALID_WEEKDAY'
  | 'INVALID_EXPIRATION_DATE'
  | 'INVALID_TICKET'
  | 'VOUCHER_DISABLED'
  | 'INVALID_CODE'
  | 'INVALID_GIFT_CARD_REDEMPTION_MODE'
  | 'ONLY_ONE_PROMO_CODE_ALLOWED'
  | 'PROMO_CODE_ALREADY_APPLIED'
  | 'PEEK_PROTECT_CONFLICT'

export function applyRedemptionCode(
  context: Object,
  variables: ApplyRedemptionCodeInput
): Promise<ApplyRedemptionCodeResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const applyRedemptionCodeMutation = useMutation<ApplyRedemptionCodeResponse, { input: ApplyRedemptionCodeInput }>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(new Error('Failed to apply redemption code.', { cause: error }))
        },
        onComplete: (data: ApplyRedemptionCodeResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    applyRedemptionCodeMutation.mutate({
      input: variables
    })
  })
}

const mutation = parse(`
  mutation ApplyRedemptionCode($input: ApplyRedemptionCodeInput!) {
    applyRedemptionCode(input: $input) {
      ... on ApplyGiftCardSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on ApplyStoreCreditSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on ApplyPromoCodeSuccess {
        warnings {
          message
        }
        quote {
          ...QuoteFragment
        }
      }
      ... on ApplyExternalVoucherSuccess {
        quote {
          ...QuoteFragment
        }
      }
      ... on Error {
        message
      }
    }
  }
  ${print(QUOTE_FRAGMENT)}
`)
